import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAnalytics, shouldLoadProductAnalytics } from "./lib/analytics";

if (shouldLoadProductAnalytics(window.location.pathname)) {
  initAnalytics();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
